/**
 * ins的http请求实例
 */
import Http from "@/api/http";
import {
  requestCookiePreLoad,
  defaultHeader,
  responseCookieFactory,
  responseDataDecode,
  responseToError,
  handleUrlBody
} from "../interceptors";
// 实例化http方法
const http = new Http({});
export default http;
/**
 * 添加cookie
 * 如果需要携带cookie，需要设置extra_data.user_id，user_id为当前登录的ins账户的user_id
 * web api 不需要携带cookie，私有api都需要携带cookie，
 * ins_user_info_getters里可以获取当前登录用户都user_id
 */
http.interceptors.request.use(
  config => requestCookiePreLoad(config),
  error => Promise.reject(error)
);
/**
 * 添加默认的header
 * 对于私有api，需要设置默认的headers，需要在extral里设置 default_headers 为true
 */
http.interceptors.request.use(
  config => defaultHeader(config),
  error => Promise.reject(error)
);
/**
 * 处理get方法的url与post方法的body
 */
http.interceptors.request.use(
  config => handleUrlBody(config),
  error => Promise.reject(error)
);
/**
 * 只有登录模式下才需要存储cookie
 * 对于登录的api，需要设置 extra_data.is_login 为true
 */
http.interceptors.response.use(
  res => responseCookieFactory(res),
  error => Promise.reject(error)
);
/**
 * 对返回结果解密
 */
http.interceptors.response.use(
  res => responseDataDecode(res),
  error => Promise.reject(error)
);
/**
 * 根据返回结果，处理错误
 * 对于非登录的私有api，需要处理lgoin_required  challenge_required feedback_required这几种情况
 * 设置extra_data.error_handle 为true
 */

http.interceptors.response.use(
  res => responseToError(res),
  error => Promise.reject(error)
);
